<template>
    <div class="home-view">
        <Topbar />
        <br>
        <div class="container-img text-left ml-2 mr-2" style="margin-top: 30px; justify-content: center;">
            <!-- Content Row -->
            <div class="card shadow col-md-6 m-auto p-0">
                <div class="card-header pt-1 pb-1" :style="{ backgroundColor: moduloAtual().color }">
                    <h6 class="m-0 font-weight-bold text-white text-center">
                        <div>
                            RSP (Pulmão) Nº {{ this.id  }}
                            <div v-show="carregando" class="spinner-grow">
                                <span class="sr-only">Loading...</span>
                            </div>
                        </div>
                    </h6>
                </div>
                
                <fieldset :disabled="carregando" class="pl-1 pr-1 pb-1">

                  <div class="card-body p-1">
                    <div class="card small mb-2" v-if="this.atividade !== null">
                        <div class="card-body p-2">
                            <span class="font-weight-bold text-danger">{{ atividade.cliente.fantasia }}</span>
                            <br>
                            <span class="font-weight-bold">Produto: </span>
                            [<span class="text-danger font-weight-bold">{{ atividade.codbarras }}</span>]
                            <br>
                            <span class="font-weight-bold">Qtde. Etoque: </span> {{ atividade.qtde_estoque }}
                            <br>
                            <span class="font-weight-bold" v-if="atividade.detalhes.tipo=1">Qtde. Reposição: </span> {{ atividade.qtde_reposicao }}
                            <br>
                            <span class="font-weight-bold">Criada: </span> {{ dateFormat(atividade.data_gravacao) }}
                            <hr>
                            <div v-if="this.enderecos.length > 0">
                                <span class="font-weight-bold">Origem (Pulmão): </span>
                                <span class="text-danger font-weight-bold">{{ this.enderecoAtual.descricao }}</span>
                                <br>
                                <span class="font-weight-bold">Qtde no endereço: </span>
                                <span class="text-danger font-weight-bold">{{ this.enderecoAtual.qtde }}</span>
                            </div>
                          </div>
                    </div>

                    <div class="small">
                        <InputDefaultApp
                            idInput="enderecoInput"
                            inputPlaceHolderSufixo="Digite o endereço destino"
                            titleScan="Escanear destino"
                            typeInputMode="numeric"
                            :errorMessage="this.enderecoDestinoErrorMessage"
                            @displayScanFunction="buscarEndereco"
                            :enterKey="(e) => buscarEndereco(e.target.value)"
                        >
                        </InputDefaultApp>
                    </div>

                    <div v-if="this.enderecoInformado" class="small">
                        <span class="font-weight-bold">Endereço Destino: </span>
                        <span class="text-danger font-weight-bold">{{ this.enderecoDestino.descricao }}</span>
                        <br>
                        <div class="row">
                            <div class="col-6 pr-1">
                                <button class="btn btn-sm btn-success btn-block mt-2" @click="showModalMovimentar()">
                                    Movimentar
                                    <em class="fa fa-arrow-right ml-2"></em>
                                </button>
                            </div>
                            <div class="col-6 pl-1">
                               <button class="btn btn-sm btn-danger btn-block mt-2" @click="cancelar()">
                                    Cancelar
                                    <em class="fa fa-ban ml-2"></em>
                                </button> 
                            </div>
                        </div>
                    </div>

                    <div class="enderecos" v-if="this.proximosEnderecos.length > 0">
                        <hr>
                        Sujestões de endereços:
                        <br>
                        <div v-for="(item) in this.proximosEnderecos" :key="item.idenderecamento">
                        <span class="text-secondary d-block">{{ item.descricao }}</span>
                        </div>
                    </div>
                  </div>

                </fieldset>
            </div>
        </div>

        <LogoutModal />
        <FooterBar />

        <div v-if="atividade != null">
            <Modal
                id="modalQuantidadeMovimentacao"
                title="Informe a Quantidade:"
                :confirmFunction="() => movimentar()"
                :cancelFunction="() => closeModal('modalQuantidadeMovimentacao')"
                confirmText="Movimentar"
                cancelText="Cancelar"
            >
                <div class="text-left small">
                    <input
                    type="number" 
                    min="0" 
                    :value="atividade.qtde_reposicao" 
                    class="form-control form-control-sm" 
                    id="quantidadeMovimentacao">
                </div>
            </Modal>

            <Modal
                id="modalRetorno"
                title="Sucesso"
                :carregando="carregando"
                :buttonList="[]"
                :cancelFunction="() => closeModal('modalRetorno')"
                cancelText="OK"
            >
                <div class="small text-center">
                    <em class="fa fa-check-circle text-success fa-3x"></em>
                    <br>
                    <br>
                    <span>{{ this.retornoMessage }}</span>
                </div>
            </Modal>
        </div>
    </div>
</template>
  
  
<script>
    // @ is an alias to /src
    import Topbar from '@/components/Topbar.vue'
    import FooterBar from '@/components/FooterBar.vue'
    import LogoutModal from '@/components/LogoutModal.vue'
    import Modal from "../components/Modal.vue";
    import ViewMixin from './ViewMixin'
    import { DEFAULT_ERROR_MESSAGE, ServerErrorException, TokenInvalidoException } from '../services/exceptions'
    import api, { getUserId, getUsername, getPerfil  } from '../services/api'
    import InputDefaultApp from "../components/InputDefaultApp.vue";
    import $ from "jquery";
    import audioService from '@/services/audioService.js';

  export default {
    name: 'RessuprimentoPulmao',
    mixins: [
      ViewMixin,
    ],
    components: {
      Topbar,
      LogoutModal,
      FooterBar,
      InputDefaultApp,
      Modal,
    },
  
    data: () => {
      return {
        id: null,
        atividade : null,
        enderecoAtual: null,
        enderecos: [],
        proximosEnderecos: [],
        enderecoInformado: false,
        enderecoDestino: null,
        enderecoDestinoErrorMessage: null,
        retornoMessage: null,
      };
    },
  
    async mounted() {
      try {
        let id = this.$route.params.id;
        this.id = id;

        await this.validarToken();
        await this.getAtividade(id);

      } catch (e) {
        if (e instanceof TokenInvalidoException) {
          this.handleTokenInvalidoException();
        } else if (e instanceof ServerErrorException) {
          alert(e.message);
        } else {
          alert(DEFAULT_ERROR_MESSAGE);
        }      
      }
    },
  
    methods: {
        getUsername,
        getPerfil,
        getUserId,

        async validarToken() {
            this.carregando = true;
    
            await api.get("/validar-token");
    
            this.carregando = false;
        },

        playSound() {
            audioService.ops();
        },

        showMessageSuccess(message) {
            this.retornoMessage = message;
            $("#modalRetorno").modal('show');
        },

        closeModal(modalId) {
            $('#'+modalId).modal('hide');
            this.onModalClosed();
        },

        onModalClosed() {
            //
        },

        async getAtividade(id) {

            this.carregando = true;

            try {

                let result = await api.get(`/atividades/${id}`);
                this.atividade = result.data.atividade;
                this.getEnderecos();
            } catch (error) {
                console.log(error);
                this.displayError = error;
            }

            this.carregando = false;
        },

        async getEnderecos() {

            this.carregando = true;

            try {
                let result = await api.post(`/atividades/enderecos`, {
                  idproduto: this.atividade.produtos_idprodutos,
                  lote: this.atividade.lote,
                  validade: this.atividade.validade
                });
                this.enderecos = result.data.enderecos;

                this.enderecoAtual = this.enderecos[0];
                this.proximosEnderecos = []
                
                let i = 0;
                for (const item of this.enderecos) {
                  if (i > 0) {
                    this.proximosEnderecos.push(item);
                  }
                  i++;
                }

            } catch (error) {
                console.log(error);
                this.displayError = error;
            }

            this.carregando = false;
        },

        async buscarEndereco(endereco) {
            try {
                let response = await api.get("/movimentacao/endereco/"+btoa(endereco));

                if (JSON.stringify(response.data).includes("descricao"))
                {   
                    if (endereco == this.enderecoAtual.descricao) {
                        this.enderecoDestinoErrorMessage = "Endereço não pode ser o mesmo de origem!";
                        this.enderecoInformado = false;
                        this.playSound();
                    } else if (response.data.descricao.trim() == endereco) {
                        $("#enderecoInput").val(response.data.descricao);
                        this.enderecoDestinoErrorMessage = "";
                        this.enderecoInformado = true;
                        this.enderecoDestino = response.data;
                    }
                } else {
                    this.enderecoDestinoErrorMessage = "Endereço não encontrado!";
                    this.enderecoInformado = false;
                    $("#enderecoInput").focus();
                    $("#enderecoInput").select();
                    this.playSound();
                }
            } catch (e) {
                this.enderecoDestinoErrorMessage = "Endereço não encontrado!";
                this.enderecoInformado = false;
                $("#enderecoInput").focus();
                $("#enderecoInput").select();
                this.playSound();
            }
        },

        cancelar() {
            this.enderecoDestino = null;
            this.enderecoInformado = false;
            $("#enderecoInput").val("");
            $("#enderecoInput").focus();
        },

        showModalMovimentar() {
            $("#modalQuantidadeMovimentacao").modal("show");
            setTimeout(() => {
                $("#quantidadeMovimentacao").focus();
                $("#quantidadeMovimentacao").select();
            }, 1000);
        },

        async movimentar() {
            this.carregando = true;

            let quantidade = document.getElementById('quantidadeMovimentacao').value;

            if (quantidade == 0 ) {
                
                setTimeout(() => {
                    document.getElementById('quantidadeMovimentacao').style.border = "1px solid red";
                    this.showModalMovimentar();
                    this.playSound();
                }, 1000);
                
            } else {
                try {
                    let body = {
                        enderecoOrigemId: this.enderecoAtual.idenderecamento,
                        enderecoDestinoDescricao: document.getElementById('enderecoInput').value,
                        idProduto: this.atividade.produtos_idprodutos,
                        idCliente: this.atividade.clientes_idclientes,
                        idUsuario: parseInt(getUserId()),
                        motivo: "RESSUPRIMENTO PULMÃO",
                        qtde: parseInt(quantidade)
                    };

                    document.getElementById('quantidadeMovimentacao').style.border = "1px solid #CCC";
                    document.getElementById('quantidadeMovimentacao').value = "";

                    this.closeModal("modalQuantidadeMovimentacao");

                    let response = await api.post("/movimentacao/interna", body);

                    if (response.status === 200) {
                        this.cancelar();
                        this.showMessageSuccess("Movimentação efetuada com sucesso!");
                        setTimeout(() => {
                            this.finalizarAtividade();
                        }, 1000);
                    }
                } catch (e) {
                    this.enderecoDestinoErrorMessage = e.message;
                    this.playSound();
                }      
            }

            this.carregando = false;
        },

        async finalizarAtividade() {
            this.carregando = true;

            try {
                let result = await api.post(`/atividades/finalizar`, {
                  id: this.atividade.idatividade
                });

                if (result.status == 200) {
                    this.$router.push("/atividades");
                }

            } catch (error) {
                console.log(error);
                this.displayError = error;
            }

            this.carregando = false;
        },
    }
  }
</script>
  
<style scoped lang="scss">
    .scroll-view {
      height: 220px;
      overflow-y: auto;
      overflow-x: hidden;
    }

    .enderecos {
      height: 110px;
      overflow-y: auto;
      overflow-x: hidden;
    }
</style>